import datepicker from '../../../../../../modules/Gull/Framework/datepicker.js';

const edit = {

	init() {

		// laad de datum kiezer voor einddatum op basis van de begindatum
		$('#Begindatum').change(function(e) {
			e.preventDefault();

			$('input#Einddatum').attr('data-enddate', $('input#Begindatum').attr('data-enddate'));
			// $('input#Einddatum').data('datepicker').setEndDate($('input#Begindatum').attr('data-enddate')); // omgezet naar onderstaande regel wegens error na bundling
			$('input#Einddatum').datepicker(datepicker.settings.date, 'setEndDate', $('input#Begindatum').attr('data-enddate'));

			$('input#Einddatum').attr('data-startdate', $('input#Begindatum').val());
			// $('input#Einddatum').data('datepicker').setStartDate($('input#Begindatum').val()); // omgezet naar onderstaande regel wegens error na bundling
			$('input#Einddatum').datepicker(datepicker.settings.date, 'setStartDate', $('input#Begindatum').val());

			edit.checkDuplicate();
		});

		// Trigger change van begindatum als pagina geladen wordt
		$('#Begindatum').trigger('change');

		// Voer controle op dubbelle invoer uit als einddatum gewijzigd wordt
		$('#Einddatum').change(function(e) {
			e.preventDefault();
			edit.checkDuplicate();
		});

		// Trigger change van einddatum als pagina geladen wordt
		$('#Einddatum').trigger('change');

	},


	// Functie om te controleren op dubbele invoer
	checkDuplicate: function() {
		if (($('#Begindatum').val() != '')) {
			$.getJSON(window.app.ajaxPath + $('#form-afstandsverklaring').data('werknemer_id') + '/' + $('#form-afstandsverklaring').data('deelname_afstandsverklaring_id') + '/duplicate-check/' + $('#Begindatum').val() + '/' + $('#Einddatum').val() + '/', function(data) {
				if (data != false) {
					// Er is een overlappend salaris
					if (!$('#form_suggestion').is(':visible')) {
						$('#form_suggestion').hide().removeClass('d-none').fadeIn();
						$('#form_continue').hide();
					}

					$('.gevonden-afstandsverklaring *').remove();
					$.each(data, function(index, val) {
						var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + val.action + '</td></tr>';
						$('.gevonden-afstandsverklaring').append(tr);
					});
				} else {
					// Er is nog geen overlappend salaris
					edit.hideFormSuggestion();
				}
			});
		}
	},

	// Verberg het blok met als deze zichtbaar is
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	}

};

export default edit;

